var map = {
	"./bilibili.svg": "dcf2",
	"./d2-admin-text.svg": "ae5c",
	"./d2-admin.svg": "bb12",
	"./kuaishou.svg": "2558",
	"./toutiao.svg": "7e65",
	"./wechat.svg": "072d",
	"./weibo.svg": "1094",
	"./xigua.svg": "523f",
	"./zhihu.svg": "ee0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec39";